import React from "react";
import { Box, Chip, IconButton } from "@mui/material";
import { Delete } from "@mui/icons-material";

export function SubcategoriesManager({
  subs,
  currentLanguage,
  languagesList,
  handleSubNameChange,
  handleRemoveSub,
  newSubId,
  setNewSubId,
  newSubName,
  setNewSubName,
  handleAddSub,
}) {
  const currentLangLabel = languagesList.find((l) => l.value === currentLanguage)?.label;

  return (
    <Box style={{ border: "1px solid #cbd5e1", borderRadius: "8px", padding: "12px", backgroundColor: "#fafafa" }}>
      <Box style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px" }}>
        <span style={{ fontSize: "0.82rem", fontWeight: "700", color: "#0f172a" }}>
          5. Subcategorias ({currentLangLabel})
        </span>
        <Chip
          label={`${subs.length} subcategorias`}
          size="small"
          style={{ backgroundColor: "#e2e8f0", color: "#334155", fontWeight: "600", fontSize: "0.72rem" }}
        />
      </Box>

      {/* List of subcategories */}
      <Box style={{ display: "flex", flexDirection: "column", gap: "6px", maxHeight: "180px", overflowY: "auto", marginBottom: "10px" }}>
        {subs.length === 0 ? (
          <span style={{ fontSize: "0.78rem", color: "#94a3b8", fontStyle: "italic", textAlign: "center", padding: "6px 0" }}>
            Nenhuma subcategoria cadastrada nesta categoria.
          </span>
        ) : (
          subs.map((sub) => (
            <Box key={sub.id} style={{ display: "flex", alignItems: "center", gap: "8px", padding: "6px 8px", backgroundColor: "#ffffff", borderRadius: "6px", border: "1px solid #e2e8f0" }}>
              <Box style={{ display: "flex", flexDirection: "column", flex: 1, gap: "2px" }}>
                <span style={{ fontSize: "0.68rem", color: "#0284c7", fontWeight: "700" }}>ID: {sub.id}</span>
                <input
                  type="text"
                  placeholder={`Nome em ${currentLangLabel}`}
                  value={sub.names?.[currentLanguage] || sub.names?.[currentLanguage + "-BR"] || sub.names?.[currentLanguage + "-US"] || ""}
                  onChange={(e) => handleSubNameChange(sub.id, e.target.value)}
                  style={{ padding: "4px 8px", fontSize: "0.82rem", border: "1px solid #cbd5e1", borderRadius: "4px", width: "100%", boxSizing: "border-box" }}
                />
              </Box>
              <IconButton onClick={() => handleRemoveSub(sub.id)} color="error" size="small">
                <Delete fontSize="small" />
              </IconButton>
            </Box>
          ))
        )}
      </Box>

      {/* Add Subcategory Controls */}
      <Box style={{ borderTop: "1px solid #e2e8f0", paddingTop: "10px", display: "flex", flexDirection: "column", gap: "6px" }}>
        <span style={{ fontSize: "0.72rem", fontWeight: "700", color: "#475569" }}>+ Nova Subcategoria</span>
        <input
          type="text"
          placeholder="ID da subcategoria (ex: trilhas_caminhadas)"
          value={newSubId}
          onChange={(e) => setNewSubId(e.target.value)}
          style={{ padding: "6px 10px", fontSize: "0.8rem", border: "1px solid #cbd5e1", borderRadius: "4px" }}
        />
        <input
          type="text"
          placeholder={`Nome da subcategoria em ${currentLangLabel}`}
          value={newSubName}
          onChange={(e) => setNewSubName(e.target.value)}
          style={{ padding: "6px 10px", fontSize: "0.8rem", border: "1px solid #cbd5e1", borderRadius: "4px" }}
        />
        <button
          type="button"
          onClick={handleAddSub}
          style={{
            padding: "6px 12px",
            alignSelf: "flex-end",
            backgroundColor: "#0284c7",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            fontSize: "0.78rem",
            fontWeight: "700",
            cursor: "pointer",
          }}
        >
          Adicionar Subcategoria
        </button>
      </Box>
    </Box>
  );
}
